<template>
  <div class="presenter-view">
    <div class="container">
      <div class="row">
        <div class="col-12 text-center">
          <h1 class="display-1">Join the Session</h1>
          <p class="lead">Scan the QR code or go to the URL below</p>
          <div class="my-5">
            <img :src="qrCodeUrl" alt="QR Code" class="qr-code img-fluid">
          </div>
          <div class="url-container">
            <h2 class="display-4">demogfe.com/{{ isClaimAccount ? 'GfE-' : 'G-' }}{{ sessionName }}</h2>
          </div>
          <div class="count-container mt-5">
            <h3 class="display-3">{{ claimedCount }} / {{ totalCount }}</h3>
            <p class="lead">Accounts Claimed</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ref, computed } from 'vue';
import { useRoute } from 'vue-router';
import getCollection from '@/composables/getCollection';

export default {
  setup() {
    const route = useRoute();
    const sessionName = route.params.sessionName;

    const { documents: students } = getCollection('students', ['sessionName', '==', sessionName]);
    const { documents: trainings } = getCollection('trainings', ['sessionName', '==', sessionName]);

    const isClaimAccount = computed(() => {
      return trainings.value && trainings.value.length > 0 && trainings.value[0].actions?.claimAccount;
    });

    const qrCodeUrl = computed(() => {
      const prefix = isClaimAccount.value ? 'GfE-' : 'G-';
      return `https://api.qrserver.com/v1/create-qr-code/?size=300x300&data=https://demogfe.com/${prefix}${sessionName}`;
    });

    const claimedCount = computed(() => {
      if (!students.value) return 0;
      return students.value.filter(s => s.isClaimed).length;
    });

    const totalCount = computed(() => {
      if (trainings.value && trainings.value.length > 0) {
        return trainings.value[0].userNumber || 100;
      }
      if (students.value) {
        return students.value.length;
      }
      return 0;
    });

    return {
      sessionName,
      qrCodeUrl,
      claimedCount,
      totalCount,
      isClaimAccount,
    };
  },
};
</script>

<style scoped>
.presenter-view {
  background-color: #f8f9fa;
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: 'Roboto', sans-serif;
}

.display-1 {
  font-weight: 700;
}

.display-3 {
  font-weight: 700;
}

.display-4 {
  font-weight: 700;
}

.qr-code {
  border: 10px solid white;
  border-radius: 10px;
  box-shadow: 0 0 20px rgba(0, 0, 0, 0.1);
}

.url-container {
  background-color: #343a40;
  color: white;
  padding: 20px;
  border-radius: 10px;
  display: inline-block;
}
</style>